import { createContext, useEffect, useState } from "react";

const initialState = {
    "user_data": {
        "account_number" : "",
        "customer_id": "",
        "first_name": "",
        "last_name": "",
        "email": "",
        "phone_no": null,
        "bank_branch": {
            "branch_code": "",
            "branch_name": "",
            "address": "",
            "city": "",
            "state": "",
            "ifsc_code": ""
        },
        "balance": ""
    }
}

export const UserDetails = createContext(null);

export const UserProvider = ({ children }) => {

    const [token, setToken] = useState("")
    const [user, setUser] = useState(initialState)


    // useEffect(() => {
    //     if (window.sessionStorage.getItem('token')) {
    //         setToken(window.sessionStorage.getItem('token'))
    //     }
    //     if (window.sessionStorage.getItem('user'))
    //         setUser(JSON.parse(window.sessionStorage.getItem('user')))
    // }, [])

    return <UserDetails.Provider value={{ user, setUser, token, setToken, initialState }}>{children}</UserDetails.Provider>
};

export default UserDetails;
